import React from "react";
import { Skeleton } from "@mui/material";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";

const PrescriptionDetailsViewSkeleton = () => {
  const theme: Theme = useTheme();

  return (
    <div style={styles.container}>
      {/* No title row: the detail view has none — the breadcrumb names the
          page — so the skeleton starts at the status/badges header. */}
      {/* Content header with badges */}
      <div style={styles.contentContainerHeader(theme)}>
        <div style={styles.badgesContainer}>
          <Skeleton variant="rectangular" width={80} height={30} style={{ borderRadius: "8px" }} />
          <Skeleton variant="rectangular" width={130} height={30} style={{ borderRadius: "8px" }} />
          <Skeleton variant="text" width={150} height={22} />
        </div>
        <Skeleton variant="circular" width={24} height={24} />
      </div>

      {/* Services skeleton - show 2 service cards */}
      <div style={styles.serviceContainer}>
        {[1, 2].map((index) => (
          <div key={index} style={styles.serviceCard(theme)}>
            {/* Service header */}
            <div style={styles.serviceHeader}>
              <div style={styles.serviceHeaderLeft}>
                <Skeleton variant="text" width={200} height={20} />
                <Skeleton variant="text" width={120} height={17} />
              </div>
              <Skeleton variant="circular" width={24} height={24} />
            </div>

            {/* Service details section */}
            <div style={styles.serviceDetailsSection}>
              <Skeleton variant="text" width={120} height={20} style={{ marginBottom: "12px" }} />
              <div style={styles.detailsGrid}>
                {[1, 2, 3, 4].map((detailIndex) => (
                  <div key={detailIndex} style={styles.detailItem}>
                    <Skeleton variant="text" width={100} height={14} />
                    <Skeleton variant="text" width="90%" height={16} />
                  </div>
                ))}
              </div>
            </div>

            {/* Logic section */}
            <div style={styles.logicSection}>
              <Skeleton variant="text" width={80} height={20} style={{ marginBottom: "12px" }} />
              <div style={styles.logicContent}>
                <Skeleton variant="text" width="100%" height={16} />
                <Skeleton variant="text" width="85%" height={16} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrescriptionDetailsViewSkeleton;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column" as "column",
    flex: 1,
    minHeight: 0,
  },
  contentContainerHeader: (theme: Theme) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px",
    borderRadius: "8px",
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    marginBottom: "16px",
    backgroundColor: theme.colors_ds.NEUTRAL_GENERAL_WHITE,
  }),
  badgesContainer: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
  },
  serviceContainer: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "16px",
  },
  serviceCard: (theme: Theme) => ({
    padding: "16px",
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    borderRadius: "8px",
    backgroundColor: theme.colors_ds.NEUTRAL_GENERAL_WHITE,
    display: "flex",
    flexDirection: "column" as "column",
    gap: "24px",
  }),
  serviceHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  serviceHeaderLeft: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "4px",
  },
  serviceDetailsSection: {
    display: "flex",
    flexDirection: "column" as "column",
  },
  detailsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "16px 32px",
  },
  detailItem: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "4px",
  },
  logicSection: {
    display: "flex",
    flexDirection: "column" as "column",
  },
  logicContent: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "8px",
  },
};
